<template>
    <!-- Page Header Start -->
    <div class="container-fluid bg-dark p-5">
      <div class="row">
        <div class="col-12 text-center">
          <h1 class="display-4 text-white">Testimonial</h1>
          <a href="">Home</a>
          <i class="far fa-square text-primary px-2"></i>
          <a href="">Testimonial</a>
        </div>
      </div>
    </div>
    <!-- Page Header End -->
  
  <!-- Testimonial Start -->
  <div class="container-fluid bg-light p-0">
    <div class="row g-0 align-items-center">
      <!-- Left Image -->
      <div class="col-lg-6">
        <img class="img-fluid w-100 h-100 object-fit-cover" :src="'/img/testimonial.jpg'" alt="Testimonial Image">
      </div>

      <!-- Right Content with Carousel -->
      <div class="col-lg-6 px-5 py-5 bg-white">
        <h2 class="fw-bold text-dark mb-4">What Say Our Client!!!</h2>

        <div class="owl-carousel testimonial-carousel">
          <!-- Testimonial 1 -->
          <div class="testimonial-item">
            <p class="fs-5 text-muted">
              <i class="fa fa-quote-left text-danger me-2"></i>
              “Nexus Focus’s risk assessment report reshaped our flood preparedness plans. We now have a community‑led early warning system in place.”
            </p>
            <div class="d-flex align-items-center mt-4">
              <img class="rounded-circle" :src="'/img/testimonial-1.jpg'" width="60" height="60" alt="Hon. Mary Wanjiku">
              <div class="ps-3">
                <h5 class="mb-0 fw-bold text-dark">Mr. Hussein ALi</h5>
                <small class="text-muted">Project Officer</small>
              </div>
            </div>
          </div>

          <!-- Testimonial 2 -->
          <div class="testimonial-item">
            <p class="fs-5 text-muted">
              <i class="fa fa-quote-left text-danger me-2"></i>
              “Their policy advocacy secured multi‑stakeholder support for our new environmental legislation—faster than we ever imagined.”
            </p>
            <div class="d-flex align-items-center mt-4">
              <img class="rounded-circle" :src="'/img/testimonial-2.jpg'" width="60" height="60" alt="Dr. Samuel Otieno">
              <div class="ps-3">
                <h5 class="mb-0 fw-bold text-dark">Dr. Samuel Otieno</h5>
                <small class="text-muted">Environmental Officer</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Testimonial End -->
</template>

<script>
export default {
  name: 'TestimonialView',
  mounted() {
    this.$nextTick(() => {
      if (window.$.fn.owlCarousel) {
        window.$('.testimonial-carousel').owlCarousel({
          items: 1,
          loop: true,
          nav: true,
          navText: [
            '<button class="btn btn-danger rounded-circle me-2"><i class="fa fa-arrow-left text-white"></i></button>',
            '<button class="btn btn-danger rounded-circle"><i class="fa fa-arrow-right text-white"></i></button>'
          ],
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          margin: 30,
          responsive: {
            0: { items: 1 },
            576: { items: 1 },
            992: { items: 1 }
          }
        });
      }
    });
  }
};
</script>

<style scoped>
.testimonial-carousel .testimonial-item {
  background-color: transparent;
  border-radius: 8px;
  overflow: hidden;
}

/* Override owl-carousel overflow */
.owl-carousel {
  overflow: visible !important;
}

/* Remove unwanted spacing */
.owl-carousel .owl-stage-outer {
  overflow: visible !important;
}

/* Optional: smooth transitions */
.owl-carousel .owl-item {
  transition: transform 0.5s ease;
}

/* Align nav buttons */
.owl-nav {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
}
</style>
